import { StateStorageService } from './../../core/auth/state-storage.service';
import { Component, OnInit } from '@angular/core';
import { Principal } from 'src/app/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
import { TypeOfClient } from 'src/app/shared/model/client.model';

@Component({
    selector: 'jhi-bulk-automatic-quotation',
    templateUrl: './bulk-automatic-quotation.component.html',
    styles: []
})
export class BulkAutomaticQuotationComponent implements OnInit {
    istypeOfClientTrader = false;

    constructor(public principal: Principal,
         private activatedRoute: ActivatedRoute,
          private stateStorageService: StateStorageService,
          private languageChangeService: LanguageChangeService
          ) { 
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    ngOnInit() {
        this.principal.identity(true).then(account => {
            console.log(account);
            if (account.typeOfClient) {
                this.clientType(account.typeOfClient);
            } else {
                const typeOfClient = this.stateStorageService.getTypeOfClient();
                this.clientType(typeOfClient);
            }
        });
    }

    clientType(typeOfClient) {
        if (typeOfClient === TypeOfClient.TRADER) {
            this.istypeOfClientTrader = true;
        } else {
            this.istypeOfClientTrader = false;
        }
    }

}
